import { useDispatch, useSelector } from 'react-redux'
import {
    CmtForm,
    FormInput,
    FormSubmit
} from './commentFormElements'
import { openFormLogin } from '../../store/reducer/authFormSlice'
import { useEffect, useRef } from 'react'

const CommentForm = ({ newsId, reply, username, parentId, closeReplyForm }) => {
    const { user, socket } = useSelector(state => state.user)
    const dispatch = useDispatch()
    const textRef  = useRef()

    useEffect(() => {
        if(reply) {
            textRef.current.value = `@${username} `
            textRef.current.focus()
        }
    }, [reply, username])
    
    const handleSubmit = e => {

        e.preventDefault()
        if(Object.keys(user).length === 0) return dispatch(openFormLogin())

        const text = textRef.current.value
        if(!text) return;

        if(reply) {
            closeReplyForm()
            socket.emit('createComment', { user, parentId, text, newsId, type: 'reply' })
        }else {
            socket.emit('createComment', { user, text, newsId, type: 'newComment' })
        }
        
        

        textRef.current.value = ''
    }

    return (
        <CmtForm reply={reply} onSubmit={handleSubmit}>
            <FormInput reply={reply} ref={textRef} placeholder="Viết bình luận của bạn"></FormInput>
            <FormSubmit reply={reply} title="Gửi bình luận">Gửi bình luận</FormSubmit>
        </CmtForm>
    )
}

export default CommentForm
